<div class="case-notes-component">
  <div class="component-actions">
    <mat-slide-toggle class="expand-all-notes-toggle"
                      color="primary"
                      [checked]="!shrinkNotes"
                      (change)="shrinkNotes = !shrinkNotes;">
      Expand All Notes
    </mat-slide-toggle>
    <div class="sort-by-div">
      Sort By:
      <select (change)="sortNotes($event)">
        <option value="created">Created Date</option>
        <option value="modified">Modified Date</option>
      </select>
    </div>
    <button mat-flat-button color="primary" (click)="showNewNote = true;" [disabled]="readOnly">
      <i class="fa-light fa-message-plus"></i>
      New Note
    </button>
  </div>
  <div *ngIf="showNewNote" [formGroup]="form" class="new-note-container">
    <mat-card class="note-cards">
      <mat-card-title class="new-note-title">New Note</mat-card-title>
      <mat-card-content>
        <!-- New Note -->
        <mat-form-field appearance="fill" class="text-area-input-100">
          <mat-label>New Note</mat-label>
          <textarea matInput formControlName="newNoteFormControl" placeholder="Enter new note here."></textarea>
          <mat-hint></mat-hint>
        </mat-form-field>
      </mat-card-content>
      <mat-divider inset></mat-divider>
      <mat-card-actions>
        <button mat-button (click)="showNewNote = false;">Cancel</button>
        <button mat-button (click)="saveNewNote()">
          <i class="fa-light fa-floppy-disk"></i>
          Save
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div class="saved-case-notes">
    <app-common-note *ngFor="let note of notes"
                     [note]="note"
                     [shrinkNotes]="shrinkNotes"
                     [readOnly]="readOnly"
                     (OnNoteSave)="saveNote($event)"
                     (OnNoteDelete)="deleteNote($event)">
    </app-common-note>
  </div>
</div>



